"use strict";
/**
 * Created by Ning Jiang on 3/15/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScatterAttentionController = void 0;
const GameConfig_1 = require("../../../core/gameconfig/GameConfig");
const ReelStopPresentationController_1 = require("../../../core/reelstoppresentation/ReelStopPresentationController");
const ArrayHelper_1 = require("../../../core/utils/ArrayHelper");
const SlotGame_1 = require("../../../core/SlotGame");
class ScatterAttentionController extends ReelStopPresentationController_1.ReelStopPresentationController {
    constructor(index, config, tweakEnabled) {
        super(index, "ScatterAttention", tweakEnabled);
        this._numOfScattersToWin = config.numOfScattersToWin;
        this._attentionSoundName = config.attentionSoundName;
        this._winAttentionSoundName = config.winAttentionSoundName;
        if (!config.scattersMap) {
            this._scattersMap = ArrayHelper_1.ArrayHelper.initArrayWithValues(GameConfig_1.GameConfig.instance.REELS_NUM, () => true);
        }
        else {
            this._scattersMap = config.scattersMap;
        }
        this._scatterPositions = ArrayHelper_1.ArrayHelper.initArrayWithValues(GameConfig_1.GameConfig.instance.REELS_NUM, () => -1);
        this._scatterCounter = 0;
    }
    parseFeatureGameData(data) {
        this._scatterPositions = data.scatterPositions != null ? data.scatterPositions : ArrayHelper_1.ArrayHelper.initArrayWithValues(GameConfig_1.GameConfig.instance.REELS_NUM, () => -1);
        this._freespinTriggered = data.freespinTriggeredThisSpin;
    }
    onReelBounce(data) {
        if (!this.tryPlayReelBouncePresentation(data)) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }
    // The inactive reel doesn't send bounce event.
    onReelSpinStopped(data) {
        if (!data.active) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }
    tryPlayReelBouncePresentation(data) {
        // No scatter
        if (this._scatterPositions[data.reelId] === -1) {
            return false;
        }
        this._scatterCounter += this.getScattersNum(data.reelId);
        // if((this._scatterCounter === (this._numOfScattersToWin - 1)) && this.isPossibleToWin(data.reelId) && !data.quickStop && !this._isStageDimmed){
        //     this._isStageDimmed = true;
        //     let dimmedSymbols:[number, number][] = [];
        //     for(let i:number = 0; i <= data.reelId; i++){
        //         for(let j:number = 0; j < symbolsNumInReel; j++){
        //             let symbol:[number, number] = [i, j];
        //             this._symbolStates[i][j] = ReelSymbol.SYMBOL_STATES.dimmed;
        //             dimmedSymbols.push(symbol);
        //         }
        //     }
        //     EventHandler.dispatchEvent(new GameEvent(ReelStopEvent.CHANGE_REEL_STOP_SYMBOL_STATE, {
        //         newState: ReelSymbol.SYMBOL_STATES.dimmed,
        //         symbols: dimmedSymbols,
        //         duration: 0.1
        //     }));
        //     EventHandler.dispatchEvent(new GameEvent(BackgroundEvent.DIM_STAGE_OVERLAY, {
        //         layer: StageManager.getLayer(SlotGameConfig.KEY_LAYER_NEAR_WIN_OVERLAY),
        //         duration: 0.2,
        //         alpha: 0.5
        //     }));
        // }
        // Shall the attention animations play in fast spin? Yes!
        // On quick stop, play "winning attention" from the first winning scatter, nothing else.
        if (data.quickStop) {
            if (this._freespinTriggered) {
                return this.playWinAttention(data);
            }
            else {
                return false;
            }
        }
        // Shall the attention on the last reel play if there is no freespin win? -No.
        if (!this.isPossibleToWin(data.reelId) && !this._freespinTriggered) {
            return false;
        }
        return this.playAttention(data);
    }
    getScattersNum(reelId) {
        // assume only one scatter on the reel. need to refactor for other games.
        return 1;
    }
    playAttention(data) {
        if (!this.playWinAttention(data)) {
            this.playAttentionAnimation(data);
            if (this._attentionSoundName) {
                SlotGame_1.SlotGame.sound.playEffect(this._attentionSoundName);
            }
        }
        return true;
    }
    playWinAttention(data) {
        if (data.reelId >= this.getFirstWinReelId()) {
            this.playWinAttentionAnimation(data);
            if (this._winAttentionSoundName) {
                SlotGame_1.SlotGame.sound.playEffect(this._winAttentionSoundName);
            }
            return true;
        }
        return false;
    }
    // override in different scatter winning rules.
    getFirstWinReelId() {
        let counter = 0;
        for (let i = 0; i < this._scatterPositions.length; i++) {
            if (this._scatterPositions[i] > -1) {
                counter++;
                if (counter === this._numOfScattersToWin) {
                    return i;
                }
            }
        }
        // no win.
        return this._scatterPositions.length;
    }
    // override in different scatter winning rules.
    isPossibleToWin(reelId) {
        let counter = 0;
        // how many scatters landed
        for (let i = 0; i <= reelId; i++) {
            if (this._scatterPositions[i] > -1) {
                counter++;
            }
        }
        // how many possible reels has scatter left
        let reelsLeft = 0;
        for (let j = reelId + 1; j < this._scatterPositions.length; j++) {
            if (this._scattersMap[j]) {
                reelsLeft++;
            }
        }
        return (counter + reelsLeft) >= this._numOfScattersToWin;
    }
    resetFeature() {
        this._scatterCounter = 0;
    }
}
exports.ScatterAttentionController = ScatterAttentionController;
//# sourceMappingURL=ScatterAttentionController.js.map